/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { DirtyType } from '@gh/common-shared-data';
import { entity, enumeration } from '@gh/core-data';
import { UserStatus } from '../users';
import { SalespersonBudgetListItemDto, SalespersonBudgetType } from './salesperson-budget.dto';

export const SalespersonBudgetListItemMapper = entity<SalespersonBudgetListItemDto>({
  status: enumeration(UserStatus),
  budgetType: enumeration(SalespersonBudgetType),
  dirtyType: enumeration(DirtyType),
});
